import {
  scrollTo,
  getElementOffsetTop,
} from 'www/utils'

function handleClickDocument({ target }) {
  try {
    const button = target.closest('.lpu-services__show-all')
    const combobox = document.querySelector('.lpu-services-search')

    if (!(button && combobox)) {
      return
    }

    scrollTo(getElementOffsetTop(combobox), {
      duration: 1000,
      offset: window.MOBILE_VERSION ? -64 : 0, // 64px высота шапки
    })
  } catch { /* Empty */ }
}

function addListenerShowAllButton() {
  document.addEventListener('click', handleClickDocument)
}

export default addListenerShowAllButton
